import {
	faCogs,
	faDownload,
	faFileAlt,
	faThList,
	faUsers,
	faUserSlash,
	faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import PATH from "../../routes/RoutePath";

export const VerticalNavData = [
	{
		label: "Manage Users",
		children: [
			{
				name: "User List",
				icon: faUsers,
				to: PATH.USERS.USERS_LIST,
				active: true,
			},
			{
				name: "Archived Users",
				icon: faUserSlash,
				to: PATH.USERS.ARCHIVED_USERS_LIST,
				active: true,
			},
			{
				name: "Create Admin User",
				icon: faUserTie,
				to: PATH.USERS.CREATE_ADMIN,
				active: true,
				superAdminAccessOnly: true
			},
		],
	},
	{
		label: "Manage Reports",
		children: [
			{
				name: "Report List",
				icon: faFileAlt,
				to: PATH.REPORTS.REPORTS_LIST,
				active: true,
			},
			{
				name: "User Report List",
				icon: faFileAlt,
				to: PATH.REPORTS.USER_REPORTS_LIST,
				active: true,
			},
			{
				name: "Export CSV File",
				icon: faDownload,
				to: PATH.REPORTS.EXPORT_CSV_FILE,
				active: true,
			},
			{
				name: "Manage Reasons",
				icon: faThList,
				to: PATH.REPORTS.MANAGE_REASONS,
				active: true,
			},
		],
	},
	{
		label: "Settings",
		children: [
			{
				name: "Configurations",
				icon: faCogs,
				to: PATH.SETTINGS.CONFIGURATIONS,
				active: true,
			},
		],
	},
];
